export enum SalesConciergeCustomerType {

    PRIVATE_COMPANY = 'Privates Unternehmen',
    PUBLIC_CLIENT = 'Öffentlicher Auftraggeber',
    HEALTH_SYSTEM = 'Gesundheitswesen',
    RETAIL = 'Einzelhandel',
    OTHER = 'Sonstige'


}

